import { useSearchPageSlicedProducts } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/useSearchPageSlicedProducts";
import { useSearchPageHasResponse } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/DataFetching/Products/useSearchPageHasResponse";
import { useSearchPagePrunedQuery } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/DataFetching/Products/useSearchPagePrunedQuery";
import { useSearchPageQueryIsLoading } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/DataFetching/Products/useSearchPageQueryIsLoading";

export const useSearchPageExactSearchReturnedNoResults = () => {
  const hasResponse = useSearchPageHasResponse();
  const isLoading = useSearchPageQueryIsLoading();
  const prunedQuery = useSearchPagePrunedQuery();
  const products = useSearchPageSlicedProducts();

  if (!hasResponse || isLoading) {
    return false;
  }
  return !!prunedQuery || !products?.length;
};
